<div class="timeline-title">
  <div class="title">EVENTS</div>
  <div class="title">NOTES</div>
</div>
<div class="loader" *ngIf="isLoading">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
  </svg>
</div>
<div class="timeline-container" *ngIf="!isLoading">
  <div class="timeline-item" *ngFor="let log of selectedLogs; index as i">
    <div class="content-area">
      <div class="delete" *ngIf="log?.isHovered"><i class="material-icons" (click)="deleteLog(log)">close</i></div>
      <ng-container *appLogRenderer="{ log }"></ng-container>
    </div>
    <div class="timeline-point-area">
      <div class="timeline-point" [ngClass]="computedClassNameForBackgroundColor(log)"><i class="material-icons" *ngIf="log.logIcon?.type === 'material'" [style.color]="computedIconColor(log)" [style.font-size]="computedIconSize(log) +'px'" style="font-size: 16px">{{ log.logIcon?.name }}</i>
        <div class="comp-icon-area" *ngIf="log.logIcon?.type === 'comp'" [class.guard-tour]="styleClassForGuardTourIcon(log)" [class.print-mode]="isMode === 'print'">
          <comp-icon [icon]="log.logIcon?.name" [color]="computedIconColor(log)" [size]="computedIconSize(log)" style="position: absolute"></comp-icon>
        </div>
      </div>
    </div>
    <div class="input-area">
      <c_card_event_viewer_time_line_input_area_component [log]="log" [isMode]="isMode"></c_card_event_viewer_time_line_input_area_component>
    </div>
  </div>
</div>